import classNames from "classnames";
import dayjs from "dayjs";
import { useContext, useMemo } from "react";
import OsteopataContext from "../../context/osteopata";
import useOsteopathDeleteMutation from "../../hooks/mutations/useOsteopathDeleteMutation";
import Requests from "../requests";

const OsteopataRequests = ({ past = false, setCancelAppointmentModal }) => {
  const { requests, labels, appLang, setCurrentRequest } = useContext(OsteopataContext);

  const currentRequests = useMemo(() => {
    const today = dayjs();
    return requests?.filter((request) =>
      past
        ? today.isAfter(dayjs(Number(request?.bookingDate)))
        : !today.isAfter(dayjs(Number(request?.bookingDate)))
    );
  }, [past, requests]);

  const handleGoToDetail = (request) => setCurrentRequest(request);

  const sortingOptions = useMemo(
    () => [
      {
        value: "BOOKING-DATE_AZ",
        label: labels?.WELFARE_BORSE_NEWEST || "Newest",
        desc: true,
      },
      {
        value: "BOOKING-DATE_ZA",
        label: labels?.WELFARE_BORSE_OLDEST || "Oldest",
        desc: false,
      },
      {
        value: "OSTEOPATA_AZ",
        label: labels?.WELFARE_OSTEOPATA_OSTEOPATA_AZ || "Osteopata AZ",
        desc: true,
      },
      {
        value: "OSTEOPATA_ZA",
        label: labels?.WELFARE_OSTEOPATA_OSTEOPATA_ZA || "Osteopata ZA",
        desc: false,
      },
      { value: "STATUS_AZ", label: labels?.WELFARE_BORSE_STATUS_AZ || "Status AZ", desc: true },
      { value: "STATUS_ZA", label: labels?.WELFARE_BORSE_STATUS_ZA || "Status ZA", desc: false },
    ],
    [labels]
  );

  const columnItemTitle = useMemo(
    () => [
      {
        label: labels?.WELFARE_OSTEOPATA_DATE || "Data prenotazione",
        name: "BOOKING-DATE",
        getContent: (request) =>
          request?.bookingDate
            ? dayjs(Number(request?.bookingDate))
                .locale(appLang?.value || "it")
                .format("L")
            : "-",
      },
      {
        label: labels?.WELFARE_OSTEOPATA_TIME || "Ora prenotazione",
        getContent: (request) =>
          request?.bookingDate
            ? dayjs(Number(request?.bookingDate))
                .locale(appLang?.value || "it")
                .format("HH:mm")
            : "-",
      },
      {
        label: labels?.WELFARE_OSTEOPATA_OSTEOPATA || "Osteopata",
        className: "table__box--big",
        name: "OSTEOPATA",
        getContent: (request) => `${request?.osteopath?.name || "-"}`,
      },
      {
        label: labels?.WELFARE_BORSE_STATUS || "Status",
        name: "STATUS",
        getContent: (request) => (
          <span className={`table__status table__status--${request?.status.toLowerCase()}`}>
            {labels?.[
              request?.status?.toUpperCase() === "COMPLETED"
                ? "WELFARE_STATUS_OSTEOPATH_COMPLETED"
                : `WELFARE_STATUS_${request?.status.toUpperCase()}`
            ] || request.status}
          </span>
        ),
      },
    ],
    [labels, appLang]
  );

  const editRequest = (request) => setCurrentRequest({ ...request, editMode: true });

  const cancelRequest = (request) => setCancelAppointmentModal(request);

  const { mutateAsync: deleteRequest, isError, reset, isLoading } = useOsteopathDeleteMutation();

  const handleDeleteRequest = async (request) => {
    console.log("deleting request", request?.id);
    await deleteRequest({ requestId: request?.id });
  };

  return (
    <div
      className={classNames(
        "app-content__section osteopata-content__requests",
        !past && "osteopata-content__requests--next"
      )}
    >
      {currentRequests?.length > 0 ? (
        <>
          <div className="app-content__title-wrapper">
            <h2 className="app-content__title">
              {past
                ? labels?.WELFARE_OSTEOPATA_PAST_REQUESTS_TITLE || "Appuntamenti precedenti"
                : labels?.WELFARE_OSTEOPATA_NEXT_REQUESTS_TITLE || "Prossimi appuntamenti"}
            </h2>
          </div>
          {past && (
            <div
              className="app-content__text"
              dangerouslySetInnerHTML={{
                __html:
                  labels?.WELFARE_OSTEOPATA_REQUESTS_DESCRIPTION ||
                  "<p>I check-up effettuati rimarranno in questo elenco fino a 2 anni dopo la data di erogazione.<br/>Superati i due anni verrano eliminati dall’elenco come previsto dalle normative sulla privacy.</p>",
              }}
            />
          )}
          <Requests
            currentRequests={currentRequests}
            setCurrentRequest={handleGoToDetail}
            labels={labels}
            sortingOptions={sortingOptions}
            columnItemTitle={columnItemTitle}
            hideSendCondition={() => true}
            type={`osteopata-${past ? "past" : "next"}`}
            defaultSorting={{ sortingDesc: past, sorting: "BOOKING-DATE" }}
            editRequest={editRequest}
            cancelRequest={cancelRequest}
            deleteObj={{
              deleteRequest: handleDeleteRequest,
              isError: isError,
              reset: reset,
              isLoading: isLoading,
            }}
          />
        </>
      ) : (
        !past && (
          <div
            className="app-content__text"
            dangerouslySetInnerHTML={{
              __html:
                labels?.WELFARE_OSTEOPATA_NO_REQUESTS ||
                "<strong>Non hai appuntamenti in agenda.</strong>",
            }}
          />
        )
      )}
    </div>
  );
};

export default OsteopataRequests;
